import Script from "next/script";
import DynamicFavicon from "@/components/theme/DynamicFavicon";
import ThemeCssLink from "@/components/theme/ThemeCssLink";
import { shouldAllowIndexing } from "@/lib/seo";

export const Head = ({
  siteTheme,
  siteHasExperiments,
  host,
}: {
  siteTheme: string;
  siteHasExperiments: boolean;
  host?: string;
}) => {
  const amplitudeApiKey = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY || "";
  const allowIndexing = shouldAllowIndexing(host || "");

  return (
    <>
      {/* eslint-disable @next/next/no-head-element */}
      <head>
        {siteHasExperiments && (
          <Script
            id="amplitude-experiment-script"
            src={`https://cdn.eu.amplitude.com/script/${amplitudeApiKey}.experiment.js`}
            strategy="afterInteractive"
          />
        )}
        <ThemeCssLink theme={siteTheme} />
        <DynamicFavicon theme={siteTheme} />
        {!allowIndexing && (
          <meta
            name="robots"
            content="noindex"
          />
        )}
      </head>
    </>
  );
};
